import React, { useState } from 'react';
import { Button } from './ui/button';
import { Instagram, Mail } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import './Contact.css';

export const Contact = () => {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, message } = formData;
    const mailtoLink = `mailto:carlotatorresll@gmail.com?subject=Contact from ${encodeURIComponent(name)}&body=${encodeURIComponent(message + '\n\nFrom: ' + name + ' (' + email + ')')}`;
    window.location.href = mailtoLink;
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        <div className="contact-header">
          <h2 className="section-title">{t('contact_title')}</h2>
          <p className="section-description">
            {t('contact_description')}
          </p>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-item">
              <Mail className="contact-icon" />
              <a href="mailto:carlotatorresll@gmail.com" className="contact-link">
                carlotatorresll@gmail.com
              </a>
            </div>
            
            <div className="contact-item">
              <Instagram className="contact-icon" />
              <a 
                href="https://instagram.com/ct.llaguno" 
                target="_blank" 
                rel="noopener noreferrer"
                className="contact-link"
              >
                @ct.llaguno
              </a>
            </div>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name" className="form-label">{t('contact_name')}</label>
              <input 
                type="text" 
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="form-input"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email" className="form-label">{t('contact_email')}</label>
              <input 
                type="email" 
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="form-input"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="message" className="form-label">{t('contact_message')}</label>
              <textarea 
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                className="form-textarea"
                rows="6"
                required
              />
            </div>

            <Button type="submit" className="submit-button">
              {t('contact_send')}
            </Button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
